import "./section.scss";

function Section(props) {
  if (props.greyFullwidthBg) {
    return (
      <div
        className={`section__bg ${props.bgClassName ? props.bgClassName : ""}`}
      >
        <div
          className={`section${props.fullWidth ? " section--full-width" : ""}${
            props.noPadding ? " section--no-padding" : ""
          } ${props.className ? props.className : ""}`}
          id={props.id}
        >
          {(props.title || props.description) && (
            <div className="section__header">
              <h2 className="section__headline" data-content={props.title}>
                {props.title}
              </h2>
              {props.description && (
                <p className="section__description">{props.description}</p>
              )}
            </div>
          )}
          {props.children}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`section${props.fullWidth ? " section--full-width" : ""}${
        props.noPadding ? " section--no-padding" : ""
      }`}
      id={props.id}
    >
      {(props.title || props.description) && (
        <div className="section__header">
          <h2 className="section__headline" data-content={props.title}>
            {props.title}
          </h2>
          {props.description && (
            <p className="section__description">{props.description}</p>
          )}
        </div>
      )}
      {props.children}
    </div>
  );
}

export default Section;
